import angular from "angular";

angular
    .module('articleHistory', [])
    .component('articleHistory', {
        controller: [controller],
        template: require('./article-history.html'),
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&'
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.article = $ctrl.resolve.article;
    };

}

export default 'articleHistory';


// WEBPACK FOOTER //
// ./resources/assets/modules/articles-control/article-history/article-history.js